"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_TRADE_OUT = exports.INTERNAL_TRADE_IN = exports.TRADE_OUT = exports.TRADE_IN = exports.WITHDRAW = exports.ADD = void 0;
exports.ADD = 'AIRMXN_ADD';
exports.WITHDRAW = 'AIRMXN_WITHDRAW';
exports.TRADE_IN = 'AIRMXN_TRADE_IN';
exports.TRADE_OUT = 'AIRMXN_TRADE_OUT';
exports.INTERNAL_TRADE_IN = 'TRADE_IN';
exports.INTERNAL_TRADE_OUT = 'TRADE_OUT';
